export default __webpack_public_path__ + "static/media/fei-usd.add0822e.png";